import lerpColor from 'app/functions/lerpColor'

const Day = ({ dodone }) => {
  if (!dodone.stats.total) return null

  return (
    <CompleteInIntervalCount dodone={dodone} colorAttribute="usedTimeRatio">
      <div>{parseInt(dodone.stats.usedTimeRatio * 100)}% utilization</div>
    </CompleteInIntervalCount>
  )
}

const CompleteInIntervalCount = ({
  dodone,
  children,
  colorAttribute = 'ratio'
}) => {
  if (!dodone.stats.total) return null

  return (
    <div
      className="dodone-stats-completed-in-interval-count"
      style={{
        backgroundColor: lerpColor(
          dodone.stats[colorAttribute],
          '#FF0000',
          '#00FF00'
        )
      }}
    >
      <div>
        {dodone.stats.completed} of {dodone.stats.total}
        {children}
      </div>
    </div>
  )
}

const StatusStreak = ({ dodone }) => {
  const status = dodone.stats?.completed ? 'completed' : 'ignored'
  if (!dodone.stats?.completed && !dodone.stats?.ignored) return null

  return (
    <div
      className="dodone-stats-base"
      style={{
        backgroundColor: status == 'completed' ? '#0A0' : '#F00'
      }}
    >
      <div className="frow items-center">
        {dodone.stats[status]}
        {status == 'completed' && <i className="ph ph-trophy ml-1" />}
        {status == 'ignored' && <i className="ph ph-x ml-1" />}
      </div>
    </div>
  )
}

function resolveView(staterName) {
  if (staterName == 'StatusStreak') return StatusStreak
  if (staterName == 'CompleteInIntervalCount') return CompleteInIntervalCount
  if (staterName == 'Day') return Day
  return null
}

const DodoneStatsBase = ({ dodone }) => {
  const StatsComponent = resolveView(dodone.stats?.attributes?.name)

  if (!StatsComponent) return null

  return <StatsComponent dodone={dodone} />
}

export default DodoneStatsBase
